const colors = {
    blue100: '#CCE4FF',
    blue200: '#99C9FF',
    blue300: '#66AEFF',
    blue400: '#006FEB',
    blue500: '#0057B8',
    blue600: '#003F85',
    blue700: '#003066',
    blue800: '#002752',
    blue900: '#000E1F',
    lightBlue100: '#D6EFF5',
    lightBlue200: '#C1E8F0',
    lightBlue300: '#ACE0EC',
    lightBlue400: '#94D6E6',
    lightBlue500: '#6CC7DC',
    lightBlue600: '#42B7D2',
    lightBlue700: '#2B9BB5',
    lightBlue800: '#21788C',
    lightBlue900: '#185563',
    darkBlue100: '#D9E3F2',
    darkBlue200: '#A1B8DE',
    darkBlue300: '#557FC3',
    darkBlue400: '#94D6E6',
    darkBlue500: '#142239',
    darkBlue600: '#0D1726',
    green100: '#F9FDF1',
    green200: '#E6F7C4',
    green300: '#C0EB6A',
    green400: '#ACE53D',
    green500: '#95D31C',
    green600: '#7FB418',
    green700: '#5F8712',
    green800: '#002752',
    green900: '#000E1F',
    warning100: '#FFF1CC',
    warning200: '#FFE499',
    warning300: '#FFDD80',
    warning400: '#FFD666',
    warning500: '#FFC832',
    warning600: '#FFBB00',
    warning700: '#CC9500',
    warning800: '#916C08',
    warning900: '#614805',
    error100: '#FFE0DB',
    error200: '#FFC1B8',
    error300: '#FFA799',
    error400: '#FF7B66',
    error500: '#FF593F',
    error600: '#FF2300',
    error700: '#CC1C00',
    error800: '#991500',
    error900: '#660E00',
    gray100: '#FFFFFF',
    gray200: '#CFD0D8',
    gray300: '#C6C8D2',
    gray400: '#AAACBB',
    gray500: '#8E90A4',
    gray600: '#71758E',
    gray700: '#5B5D71',
    gray800: '#2D2F39',
    gray900: '#17171C',
};
export default colors;
//# sourceMappingURL=colors.js.map